/**
 * Product social proof
 * Cycles overlapping avatars one-by-one, then loops.
 */
if (!customElements.get('product-social-proof')) {
  class ProductSocialProof extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.avatars = Array.from(this.querySelectorAll('[data-psp-avatar]'));
      this.visibleCount = Math.max(1, Number(this.dataset.visible) || 3);
      this.avatarSize = Number(this.dataset.avatarSize) || 28;
      this.overlap = Number(this.dataset.overlap) || 0.8;
      this.intervalMs = Math.max(1200, Number(this.dataset.interval) || 2200);
      this.animate = this.dataset.animate !== 'false';
      this.step = 0;

      if (this.avatars.length === 0) return;

      this.visibleCount = Math.min(this.visibleCount, this.avatars.length);
      this.render();

      if (!this.animate || this.avatars.length <= this.visibleCount) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.timer = window.setInterval(() => {
        this.step = (this.step + 1) % this.avatars.length;
        this.render();
      }, this.intervalMs);
    }

    disconnectedCallback() {
      if (this.timer) window.clearInterval(this.timer);
    }

    render() {
      const park = this.avatarSize * 3.85;
      const slotWidth = this.avatarSize * this.overlap;

      this.avatars.forEach((el, index) => {
        const relative = (index - this.step + this.avatars.length) % this.avatars.length;
        const isVisible = relative < this.visibleCount;

        el.style.zIndex = String(isVisible ? 10 + relative : 1);
        el.classList.toggle('is-visible', isVisible);

        if (isVisible) {
          el.style.transform = `translateX(${relative * slotWidth}px) scale(1)`;
        } else {
          // Park off to the right; next in line sits closest to the stack
          const queueIndex = relative - this.visibleCount;
          const x = park + queueIndex * (this.avatarSize * 0.35);
          el.style.transform = `translateX(${x}px) scale(0.92)`;
        }
      });
    }
  }

  customElements.define('product-social-proof', ProductSocialProof);
}
